import { FileHolder } from 'angular2-image-upload';
import { SnotifyService } from 'ng-snotify';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators } from '@angular/forms';
import { DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Component, OnInit } from '@angular/core';
import { Local } from 'src/app/shared/models/local.model';
import { LocalsService } from '../../locals.service';
import moment from 'moment';
import { SharedService } from 'src/app/shared/shared.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CreateComponent implements OnInit {
  currentId = undefined;
  local = new Local();
  localForm: DVFormGroup;
  profilePictures = [];
  isAddState = true;
  cities: any = [];
  languages = [];

  multiDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'code',
    textField: 'name',
    allowSearchFilter: true
  };

  constructor(
    public route: ActivatedRoute,
    private localService: LocalsService,
    private sharedService: SharedService,
    private notifier: SnotifyService,
    private router: Router
  ) {

    this.localForm = new DVFormGroup({
      fname: new DVFormControl(null, {
        'First Name is required': Validators.required
      }),
      lname: new DVFormControl(null, {
        'Last Name is required': Validators.required
      }),
      profession: new DVFormControl(null, {
        'Profession is required': Validators.required
      }),
      hobbies: new DVFormControl(null, {
        'Hobbies is required': Validators.required
      }),
      phone: new DVFormControl(null, {
        'Phone is required': Validators.required
      }),
      birthdate: new DVFormControl(null, {
        'Birth date is required': Validators.required
      }),
      languages: new DVFormControl(null),
      email: new DVFormControl(null, {
        'Email is required': Validators.required,
        'Please enter a valid email address.': Validators.email
      }),
      emergencyPhone: new DVFormControl(null, {
        'Emergency Phone is required': Validators.required
      }),
      profilePicture: new DVFormControl([], {
        'profilePicture is required': Validators.required
      }),
      cityId: new DVFormControl(null, {
        'City is required': Validators.required
      }),
      about: new DVFormControl(null, {
        'About is required': Validators.required
      }),
      canProvideAccommodation: new DVFormControl(false),
    });
  }

  ngOnInit() {
    this.currentId = this.route.snapshot.params.id;

    if (this.currentId) {
      this.isAddState = false;
      this.loadLocal();
    }
    this.loadCities();
    this.loadLanguages();
  }

  SubmitForm() {
    if (this.localForm.invalid) {
      this.localForm.forceShowErrors();
      return;
    }

    const body = this.getFormData();
    this.localService.createLocal(body).subscribe(
      res => {
        this.notifier.success('Local Created Successfully');
        this.router.navigateByUrl('/locals/list');
      },
      err => {
        this.notifier.error(err.error.userMessage);
      }
    );
  }

  editForm() {
    if (this.localForm.invalid) {
      this.localForm.forceShowErrors();
      return;
    }

    const body = this.getFormData();
    this.localService.editLocal(this.currentId, body).subscribe(
      res => {
        this.notifier.success('Local Updated Successfully');
        this.router.navigateByUrl('/locals/list');
      },
      err => {
        this.notifier.error(err.error.userMessage);
      }
    );
  }

  getFormData() {
    return {
      email: this.localForm.get('email').value,
      firstName: this.localForm.get('fname').value,
      lastName: this.localForm.get('lname').value,
      birthdate: this.localForm.get('birthdate').value,
      profilePicture: this.localForm.get('profilePicture').value[0].url,
      phoneNumber: this.localForm.get('phone').value,
      languages: (this.localForm.get('languages').value || []).map(v => v.code),
      cityId: this.localForm.get('cityId').value,
      LocalInfo: {
        about: this.localForm.get('about').value,
        profession: this.localForm.get('profession').value,
        hobbies: this.localForm.get('hobbies').value,
        canProvideAccommodation: this.localForm.get('canProvideAccommodation').value,
        emergencyPhoneNumber: this.localForm.get('emergencyPhone').value
      }
    };
  }

  loadLocal() {
    this.localService.getLocalByUUID(this.currentId).subscribe(res => {
      this.fillFormData(res.data);
    }, err => {
      console.log(err);
    });
  }

  fillFormData(data) {
    this.localForm.controls.fname.setValue(data.profile.firstName);
    this.localForm.controls.lname.setValue(data.profile.lastName);
    this.localForm.controls.email.setValue(data.profile.email);
    this.localForm.controls.cityId.setValue(data.profile.cityId);

    const birthdate = moment(data.profile.birthdate).format('YYYY-MM-DD');
    this.localForm.controls.birthdate.setValue(birthdate);

    this.profilePictures = [{ url: data.profile.profilePicture }];
    this.localForm.controls.profilePicture.setValue([{ url: data.profile.profilePicture }]);

    this.localForm.controls.languages.setValue(data.profile.Languages);

    this.localForm.controls.phone.setValue(data.profile.phoneNumber);
    this.localForm.controls.profession.setValue(data.profile.LocalInfo.profession);
    this.localForm.controls.hobbies.setValue(data.profile.LocalInfo.hobbies);
    this.localForm.controls.about.setValue(data.profile.LocalInfo.about);
    this.localForm.controls.emergencyPhone.setValue(data.profile.LocalInfo.emergencyPhoneNumber);
    this.localForm.controls.canProvideAccommodation.setValue(data.profile.LocalInfo.canProvideAccommodation);
  }

  cancel() {
    this.router.navigateByUrl('/locals/list');
  }

  //#region Country & City

  loadCities() {
    this.localService.getAllCities(65).subscribe(res => {
      this.cities = [];
      this.cities = res.data.cities;
    });
  }
  //#endregion


  loadLanguages() {
    this.sharedService.languages().subscribe(response => {
      this.languages = response.data.languages;
    });
  }
}
